export const secondSection = [
  { name: "PE Mínimo", translation: 'Minimum Stock Policy'},
  { name: "PE Máximo", translation: 'Maximum Stock Policy'},
  { name: "Consumo", translation: 'P.H. Requirement' },
  { name: "Saldo Final", translation: 'Final Balance'},
  { name: "Saldo Com PE", translation: 'Value Stock Policy' },
  { name: "Riscos Passivos Final", translation: 'Final Passive Risks'}
]
